export default "__VITE_ASSET__DcwWe8lE__"